import { render, staticRenderFns } from "./sample2.vue?vue&type=template&id=1197f4dd&lang=pug&"
import script from "./sample2.vue?vue&type=script&lang=js&"
export * from "./sample2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports